import { Box, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { FC, useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { useAppDispatch, useAppSelector } from "store";
import { FloorplanCanvas } from "components/FloorplanCanvas";
import { asyncQueries } from "store/slices/floorplans.queries";
import { selectFloorplans } from "store/slices/floorplans.store";
import { InspectionInputType, SpecificationType } from "operations/schema/schema";

interface FloorplanTabProps {
  equipmentId?: number;
  setFab?: React.Dispatch<React.SetStateAction<JSX.Element | undefined>>;
  specifications: SpecificationType[];
  inspections: InspectionInputType[];
}

export const FloorplanTab: FC<FloorplanTabProps> = ({ setFab, equipmentId, specifications, inspections}) => {
  const dispatch = useAppDispatch();
  const intl = useIntl();
  const [selectedFloor, setSelectedFloor] = useState<string>("");
  const floorplans = useAppSelector(selectFloorplans);

  useEffect(() => {
    if (setFab) {
      setFab(undefined); 
    }
  }, [setFab]);

  useEffect(() => {
    if (equipmentId) {
      dispatch(asyncQueries.getFloorplansByEquipmentId(equipmentId))
        .then((action) => {
          if (asyncQueries.getFloorplansByEquipmentId.fulfilled.match(action)) {
            const floorplansData = action.payload?.floorplans;
            if (floorplansData?.length > 0) {
              setSelectedFloor(floorplansData[0].floorName); 
            }
          } else {
            console.warn("[FloorplanTab] Failed to fetch floorplans:", action);
          }
        });
    } else {
      console.log("[FloorplanTab] No equipmentId provided");
    }
  }, [equipmentId, dispatch]);

    return (
    <Box
      data-testid="FloorplanTabContainer"
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100vh",
        overflow: "hidden",
        paddingTop: 2
      }}
    >
      <FormControl fullWidth sx={{ mb: 2, px: 2 }}>
        <InputLabel id="floor-select-label" sx={{ pl: 2.5}}>
          <FormattedMessage id="floorplan.selectFloor" defaultMessage="Select Floor" />
        </InputLabel>
        <Select
          labelId="floor-select-label"
          value={selectedFloor}
          onChange={(e) => setSelectedFloor(e.target.value)}
          label={intl.formatMessage({ id: "floorplan.selectFloor", defaultMessage: "Select Floor" })}
        >
          {floorplans.map((fp) => (
            <MenuItem key={fp.id} value={fp.floorName}>
              {fp.floorName}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <Box
        sx={{
          flexGrow: 1,
          position: "relative",
          minHeight: 0,
          overflow: "hidden",
          p: 0
        }}
      >
        <FloorplanCanvas
          floor={selectedFloor}
          floorplans={floorplans}
          specifications={specifications}
        />
      </Box>
    </Box>
  );
};